module.exports = __webpack_public_path__ + "static/media/loader.fa21a73a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = 639
// module chunks = 2